
(function($){
	$(function(){

       



$('#cart-icon-bubble').click(function(){
  window.location.href = '/cart';
})
      


        $('.hamburger').click(function () {
            $("body").toggleClass("navShown");
            $(".nav-wrap.nav-left").fadeToggle()
        });

        if ($("select.styled-select").length) {
            $("select.styled-select").selectric({
            });
        }


      const triggerEvent = (element,eventName) =>{
          const event = new Event(eventName);
          element.dispatchEvent(event);
      };

       $("select.styled-select").change(function() {
        if(( $('option:selected', this).text() =='GER' )){
              $('.tl-option[data-value="de"]').trigger('click');
            } else if (( $('option:selected', this).text() =='FR' )) {
              $('.tl-option[data-value="fr"]').trigger('click');
            } else if (( $('option:selected', this).text() =='EN' )) {
              $('.tl-option[data-value="en"]').trigger('click');
            }
        });
      
      $(document).ready(function(){
        setTimeout(function() {
            $('header').removeClass('fadeOut');
            $('header').addClass('fadeIn');
          console.log('loaded!');
        }, 3000);
      });
      
            

      
      

  if($(window).width() > 991){
    $('.home-tab-trigger ul li').eq(0).addClass('active')
          $('.home-tab-trigger ul li').click(function (e) {
              e.preventDefault();
              $('.home-tab-trigger ul li').removeClass('active');
              $(this).addClass('active');
              $('.home-tab-thumb').hide();
              var activeTab = $(this).find('button').attr('href');
              $(activeTab).fadeIn();
              return false;
          });
  }

      $('ul.dropdown').parent('li').addClass('hasNav')
      if ($(window).width() > 991) {
        $('li.hasNav > a').mouseenter(function(){
          $('ul.dropdown').fadeIn();
          $(this).addClass("is-active");
        })
        $('li.hasNav').mouseleave(function(){
          $('ul.dropdown').fadeOut();
          $(this).find("a").removeClass("is-active");
        })
     }
       if ($(window).width() < 992) {
        $('li.hasNav > span').click(function(){
          $('ul.dropdown').slideToggle();
          $(this).parent('li').toggleClass('active')
        })
     }


    

      if($('.home-tab-thumb-wrap').length){
        $('.home-tab-thumb-wrap').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      infinite: true,
      mobileFirst: true,
      asNavFor: ".home-tab-trigger ul",
      responsive: [
            {
                    breakpoint: 992,
                    settings: 'unslick'
            }
         ]
        });
        $(window).on('resize', function () {
                $('.home-tab-thumb-wrap').slick('resize');

            });
      }
        $('.shop-single-tab-trigger ul li').click(function () {
            $('.shop-single-tab-trigger ul li').removeClass('active');
            $(this).addClass('active');
            $('.shop-single-tab-item').hide();
            var activeTab = $(this).find('a').attr('href');
            $(activeTab).fadeIn();
            return false;
        });
        // End Shop Style

        if ($('.shop-single-tab-trigger').length) {
            var imageShower = $('.shop-single-tab-item img')
            $('.shop-single-tab-trigger ul a').each(function () {
                var $$this = $(this);
                $$this.click(function (e) {
                    e.preventDefault();
                    var $thisUrl = $(this).attr('href');
                    imageShower.attr('src', $thisUrl)
                })
            })
        }


        // Start Cart function
        if ($('.cart-section').length) {
            $('body').addClass('cart-page')
        }
        // End Cart function

        // Start Thank you function
        if ($('.thank-you').length) {
            $('body').addClass('thank-you-page')
        }
        // End Thank you function     

        // Start Blog JS
        $(function () {
            $(".blog .sustainbility-item").slice(0, 3).show();
            $(".blog-btn a").on('click touchstart', function (e) {
                e.preventDefault();
                $(".blog .sustainbility-item:hidden").slice(0, 1).slideDown();
                if ($(".blog .sustainbility-item:hidden").length == 0) {
                    $(".blog-btn").fadeOut();
                }
                // $('html,body').animate({
                //     scrollTop: $(this).offset().top
                // }, 1000);
            });
        });
        // End Blog JS

        // Start Business JS
        if ($('.fully-customize-item-wrap').length) {
            $('.fully-customize-item-wrap').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                arrows: false,
                mobileFirst: true,
                adaptiveHeight: true,
                responsive: [
                    {
                        breakpoint: 768,
                    }
                ]
            })
        
            $(window).on('resize', function () {
                $('.fully-customize-item-wrap').slick('resize');
                });
        }
        // End Business JS


      $('#create_customer').wrap('<div class="create_customer_wrap"></div>');

      if($('._1fragem3w._1fragem48._1fragem3k._1fragem4f._1fragemnq._1fragemp2._1fragemme._1fragemqe._1fragemo._1fragemsm._1fragem4k._1fragem1o._1fragemhq._1fragemj2').length){
        $('body').addClass('b2b')
      }

      var sRc = $('#cl7uedzmzivp input[type=hidden]').val();
      //$('#UploadPhotoImg')


          if ($('.blog-component-wrap').length) {
            $('.blog-component-wrap').slick({
                autoplay: false,
                autoplaySpeed: 1500,
                slidesToShow: 1,
                slidesToScroll: 1,
                mobileFirst: true,
                arrows: false,
                dots: false,
                responsive: [
                    {
                            breakpoint: 767,
                            settings: 'unslick'
                    }
                ]
            })
        
            $(window).on('resize', function () {
                $('.blog-component-wrap').slick('resize');
            });
        }

      $('.shop-single-radio-content').parent('.shop-single-radio-row-inner').addClass('custom-color')
        $('.custom-color > input').change(function(){
            $('.shop-single-radio-content').slideToggle();
            $(this).parent('.shop-single-radio-row-inner').toggleClass("active");
        })

      
      // $(window).on('load', function () {
      //   setTimeout(function () {
          
        
      //      if ($('ul#Slider-Thumbnails-template--16821362196783__main').length) {
      //           $('ul#Slider-Thumbnails-template--16821362196783__main').slick({
      //               autoplay: false,
      //               autoplaySpeed: 1500,
      //               slidesToShow: 1,
      //               slidesToScroll: 1,
      //               mobileFirst: true,
      //               arrows: true,
      //               dots: false,
      //               responsive: [
      //                   {
      //                           breakpoint: 991,
      //                           settings: 'unslick'
      //                   }
      //               ]
      //           })
            
      //           $(window).on('resize', function () {
      //               $('ul#Slider-Thumbnails-template--16821362196783__main').slick('resize');
      //           });
      //       }
      //     }, 1000)
      //  });



       
      // if($('.rectangle-inner').length){
        
      //   var offsetTop = $('.rectangle-inner span').offset().top;
      //   var windowHeight = $(window).outerHeight() / 1.2;
      //   var secInView = offsetTop - windowHeight;
      //   var a = 0;
        
      //   $(window).on('scroll', function(){
      //     var scrollY = $(this).scrollTop();
      //     if(a == 0 && scrollY > secInView){
      //       $('.rectangle-inner span').each(function () {
      //         var size = $(this).text().split(".")[1] ? $(this).text().split(".")[1].length : 0;
      //         $(this).prop('Counter', 0).animate({
      //           Counter: $(this).text()
      //         }, {
      //           duration: 2500,
      //           step: function (func) {
      //             $(this).text(parseFloat(func).toFixed(size));
      //           }
      //         });
      //       });
      //       a = 1;
      //     }
      //   })
      // }

    //   var a = 0;
    //      $(window).scroll(function () {
    //          var oTop = $(".rectangle-inner").offset().top - window.innerHeight;
    //          if (a == 0 && $(window).scrollTop() > oTop) {
    //              $(".rectangle-inner span").each(function () {
    //                  var $this = $(this),countTo = $this.text();
    //                  $(this).text('')
    //                  $({
    //                      countNum: $this.text()
    //                  }).animate({
    //                      countNum: countTo
    //                  }, {
    //                      duration: 2850,
    //                      easing: "swing",
    //                      step: function () {
    //                          //$this.text(Math.ceil(this.countNum));
    //                          $this.text(
    //                             Math.ceil(this.countNum).toLocaleString("en")
    //                          );
    //                      },
    //                      complete: function () {
    //                          $this.text(
    //                             Math.ceil(this.countNum).toLocaleString("en")
    //                          );
    //                          //alert('finished');
    //                      }
    //                  });
    //              });
    //              a = 1;
    //          }
    //      });


    //   setTimeout(function(){
    //      $('header').removeClass('fadeOut');
    //    }, 500);

     
      
        // setTimeout(function(){
        //      $('div.grid__item.product__media-wrapper').addClass('fade_In');
        //   }, 1700);

       $(".frequently-askq-item").each(function () {
            var $this = $(this);
            $this.find("h3").on("click touch", function () {
                $(".frequently-askq-item").removeClass("active")
                $(".frequently-askq-item-content").slideUp();
                if ($this.find(".frequently-askq-item-content:visible").length) {
                    $(".frequently-askq-item").removeClass("active")
                    $(".frequently-askq-item-content").slideUp();
                } else {
                    $this.addClass("active")
                    $(".frequently-askq-item-content").slideUp();
                    $this.find(".frequently-askq-item-content").slideDown();
                }
            })
        });
      
      if ($('.home-tab-trigger ul').length) {
            $('.home-tab-trigger ul').slick({
                autoplay: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                mobileFirst: true,
                arrows: false,
                dots: false,
                fade: true,
                infinite:false,
                asNavFor: ".home-tab-thumb-wrap",
                responsive: [
                    {
                            breakpoint: 991,
                            settings: 'unslick'
                    }
                ]
            })
        
            $(window).on('resize', function () {
                $('.home-tab-trigger ul').slick('resize');
            });
        }


      // if($(window).width() > 991){
        // console.log('desktop')
        // $('#Slider-Thumbnails-template--16821362196783__main #Slide-Thumbnails-template--16821362196783__main-0').click(function(){
        //   $('#template--16821362196783__main-1-0 + label').stop(true, true).click();
        // });
        // $('#Slider-Thumbnails-template--16821362196783__main #Slide-Thumbnails-template--16821362196783__main-2').click(function(){
        //   $('#template--16821362196783__main-1-1 + label').stop(true, true).click();
        // });
        // $('#Slider-Thumbnails-template--16821362196783__main #Slide-Thumbnails-template--16821362196783__main-3').click(function(){
        //   $('#template--16821362196783__main-1-2 + label').stop(true, true).click();
        // });
        // $('#Slider-Thumbnails-template--16821362196783__main #Slide-Thumbnails-template--16821362196783__main-4').click(function(){
        //   $('#template--16821362196783__main-1-3 + label').stop(true, true).click();
        // })
      // }

       $('#GalleryViewer-template--16821362196783__main').click(function (e) {
            e.stopPropagation();
        });


              const chooseFile = document.getElementById("logo");
              const imgPreview = document.getElementById("img-preview");
      
              chooseFile.addEventListener("change", function () {
              getImgData();
              });
      
                function getImgData() {
                const files = chooseFile.files[0];
                if (files) {
                    const fileReader = new FileReader();
                    fileReader.readAsDataURL(files);
                    fileReader.addEventListener("load", function () {
                    imgPreview.style.display = "block";
                    imgPreview.innerHTML = '<img src="' + this.result + '" />';
                    });    
                }
              }

       $('#cart-icon-bubble').click(function (e) {
            e.stopPropagation();
        });


      // $('ul.dropdown li a[href*="#"]:not([href="#"])').click(function () {

      //       if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      //           var target = $(this.hash);
      //           target = target.length ? target : $('[name=' + this.hash.slice(0) + ']');
      //           if (target.length) {
      //               $('html, body').animate({
      //                   scrollTop: target.offset().top - 100
      //               }, 600);
      //               return false;
      //           }
      //       }
      //   });
      
      // $( 'ul.dropdown li a' ).on( 'click', function(e){
      //   var href = $(this).attr( 'href' );
      //   $( 'html, body' ).animate({
      // 		scrollTop: $( href ).offset().top
      //   }, '300' );
      //   e.preventDefault();
      
      // });

      //  $('ul.dropdown li a[href^=#]').on('click', function(e){
      //     e.preventDefault();
      //     var href = $(this).attr('href');
      //     $('html, body').animate({ 
      //         scrollTop:$(href).offset().top
      //     },'slow');
      // });



      

       
      
		
	})// End ready function.
   
    
   
	
         $('.nav-left ul li:last').addClass('shop mobi');

        

})(jQuery)

function increaseCount(e, el) {
    var input = el.previousElementSibling;
    var value = parseInt(input.value, 10);
    value = isNaN(value) ? 0 : value;
    value++;
    input.value = value;
}

function decreaseCount(e, el) {
    var input = el.nextElementSibling;
    var value = parseInt(input.value, 10);
    if (value > 1) {
        value = isNaN(value) ? 0 : value;
        value--;
        input.value = value;
    }
}

